import { useTranslation } from 'next-i18next'

import MultiSelect from '~/components/MultiSelect'
import { LevelOfEducation } from '~/types/booking'

export default function SelectLevelsOfEducation({
  levelsOfEducation,
  onClick,
}: {
  levelsOfEducation: LevelOfEducation[]
  onClick: (levelsOfEducation: LevelOfEducation[]) => void
}): React.ReactElement {
  const { t } = useTranslation('booking')

  const handleOnClick = (item: LevelOfEducation): void => {
    const newState = levelsOfEducation.includes(item)
      ? levelsOfEducation.filter((levelOfEducation) => levelOfEducation !== item)
      : [...levelsOfEducation, item]

    onClick(newState)
  }

  const items = Object.values(LevelOfEducation).map((elem) => ({
    value: elem,
    label: t(`subjects.levelsOfEducation.${elem}`),
  }))

  return (
    <div className="space-x-2">
      <MultiSelect handleOnClick={handleOnClick} items={items} state={levelsOfEducation} />
    </div>
  )
}
